import { useUser } from "../use-user";

export const useIsImpersonatedSession = () => {
  const user = useUser();
  return !!user?.is_impersonated_session;
};
